import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from "../../../../configs/app";
import { ReservationService } from "../../../../services/reservation.service";
import { CartService } from "../../../../services/cart.service";
import { CommonService } from "../../../../services/common.service";
import { PlanService } from "../../../../services/plan.service";
import { FormatterService } from "../../../../services/formatter.service";
import { AnalyticsService } from "../../../../services/analytics.service";

declare var Paidy: any; /* Paidy */

@Component({
  selector: 'page-reserve-checkout-index',
  templateUrl: './index.component.html',
})
export class PageReserveCheckoutIndexComponent implements OnInit {

  public postData: any;
  public cartData: any;
  public userList: any;
  public listUser: any;
  public planPrice: any;
  public insuranceData: any;
  public priceCalculation: any = {};
  public paymentText = {
    text: "コンビニ・ネットバンク決済"
  }
  public paymentTypeCard: boolean = false;
  public paymentTypeBank: boolean = false;
  public paymentTypePaypay: boolean = false;
  public paymentTypePaidy: boolean = false;
  public paymentTypePostPay: boolean = false;
  public _: any;

  public combined : any = [];
  public paymentData : any;

  public divisionData: any;

  public couponData: any;

  public seatData: any = [];

  /* BUS SETTINGS */
  public busSettings: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  public planDetail: any;

  constructor(
    public appConfig: AppConfig,
    public activatedRoute: ActivatedRoute,
    public reservationService: ReservationService,
    public cartService: CartService,
    public commonService: CommonService,
    public planService: PlanService,
    public formatterService: FormatterService,
    private analyticsService: AnalyticsService
  ) {
    this._ = this.commonService.getLodash();
  }

  async ngOnInit() {
    /* GET RIDIRECT PAYPAY FINISH DATA */
    let error_message = this.activatedRoute.snapshot.queryParams.error_message;
    let is_show_popup = this.activatedRoute.snapshot.queryParams.is_show_popup === '1';
    if(error_message){
      if(is_show_popup) {
        this.showPopError()
        return {}
      }
      /* SET ERROR MESSAGE */
      let message = [];
      message.push(`予約に失敗しました。`);
      message.push(error_message);
      message.push(`ご情報をご確認ください。`);
      this.tempData.checkOutErrorMessage = message.join("<br>");
      /* END */
    }

    this.commonService.showPageLoader("読み込み中...");

    this.commonService.removeBatchData([
      this.appConfig.reservation.reservationCompleteDataSessionName,
    ]);

    /* GET BUS SETTINGS */
    this.busSettings = this.commonService.getData(this.commonService.appConfig.site.settingSessionName);

    this.insuranceData = this.reservationService.getInsuranceData();

    this.cartData = this.cartService.getCartData();

    this.userList = await this.reservationService.getPassengerData();
    this.postData = this.reservationService.getReservationData();
    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.postData) || this._.isEmpty(this.userList)) {
      return this.commonService.redirectToRoute(this.commonService.routePaths.pagePlanList);
    }

    /* CHECK PAYMENT METHOD */
    const paymentType = this.appConfig.reservation.paymentType;
    const paymentMethod = this.postData.payment_method;
    if (
      paymentMethod != paymentType.creditCard &&
      paymentMethod != paymentType.bank &&
      paymentMethod != paymentType.postpay &&
      paymentMethod != paymentType.paypay &&
      paymentMethod != paymentType.paidy
    ) {
      return this.commonService.redirectToRoute(this.commonService.routePaths.pageReservePaymentNoParam);
    }

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();
    if (this.cartData.length > 0) {
      this.planDetail = await this.planService.getPlanDetail(
        this.cartData[0].planCode,
        this.cartData[0].targetDay
      )
    }

    this.postData.c_coty_name = this.divisionData.division_map.id_bb[parseInt(this.postData.c_coty_id) + 3].name;
    /* END */

    if(this.postData.payment_method == this.appConfig.reservation.paymentType.creditCard){
      this.paymentText.text = "クレジットカード";
      this.paymentTypeCard = true;
    }else if(this.postData.payment_method == this.appConfig.reservation.paymentType.bank){
      this.paymentText.text = "コンビニ・ネットバンク決済";
      this.paymentTypeBank = true;
    }else if(this.postData.payment_method == this.appConfig.reservation.paymentType.paypay){
      this.paymentText.text = "PAYPAY決済";
      this.paymentTypePaypay = true;
    }else if(this.postData.payment_method == this.appConfig.reservation.paymentType.paidy){
      this.paymentText.text = "あと払い（ペイディ）";
      this.paymentTypePaidy = true;
    }else{
      this.paymentText.text = "後払い決済";
      this.paymentTypePostPay = true;
    }

    this.listUser = this.userList[0].list;
    let key: any;
    for ( key of this.listUser){
      if(key.sex == 1){
        key['sexName'] = "男性";
      } else {
        key['sexName']= "女性";
      }
    }

    let tempUser1: any = [];
    for (let i = 0; i < this.listUser.length; i++) {
      tempUser1.push({
        sei: this.postData['1_p_sei_'+(i+1)],
        mei: this.postData['1_p_mei_'+(i+1)],
        age: parseInt(this.postData['1_p_age_'+(i+1)]),
        sexName: this.postData['1_p_sex_'+(i+1)] == 1 ? "男性" : "女性",
        tel: this.postData['1_p_tel1_'+(i+1)]+this.postData['1_p_tel2_'+(i+1)]+this.postData['1_p_tel3_'+(i+1)],
      });
    }
    this.combined.push(tempUser1);

    let tempUser2: any = [];
    if(this.cartData.length == 2){
      let listUser2 = this.userList[1].list;
      for (let i = 0; i < listUser2.length; i++) {
        tempUser2.push({
          sei: this.postData['2_p_sei_'+(i+1)],
          mei: this.postData['2_p_mei_'+(i+1)],
          age: parseInt(this.postData['2_p_age_'+(i+1)]),
          sexName: this.postData['2_p_sex_'+(i+1)] == 1 ? "男性" : "女性",
          tel: this.postData['2_p_tel1_'+(i+1)]+this.postData['2_p_tel2_'+(i+1)]+this.postData['2_p_tel3_'+(i+1)],
        });
      }
      this.combined.push(tempUser2);
    }

    /* CALCULATE TOTAL AMOUNT */
    let calculatedData = await this.reservationService.calculateTotalAmount(this.cartData, this.insuranceData, this.priceCalculation, this.postData, this.couponData, this.listUser, this.userList, this.seatData);
    this.couponData = calculatedData.couponData ? calculatedData.couponData : this.couponData;
    this.seatData = calculatedData.seatData ? calculatedData.seatData : this.seatData;

    if(!this._.isEmpty(this.couponData)){
      this.postData['coupon_code'] = this.couponData.code;
    }

    /* REFERRER */
    let referrer = this.commonService.getData(this.commonService.appConfig.plan.referrerSessionName);
    this.postData["referer"] = referrer ? referrer.referrer : document.referrer;

    this.postData["totalCartPrice"] = this.priceCalculation.totalCartPrice;
    for (let i = 0; i < this.cartData.length; i++) {
      this.postData[(i+1)+"_cartPrice"] = this.cartData[i].totalPrice;
    }

    /* PAYMENT DATA */
    this.paymentData = this.reservationService.getPaymentCalcData();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async finalStep() {

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("予約の最終確認中です。");

    try {

    /* REMOVE LAST ERROR MESSAGES */
    delete this.tempData.checkOutErrorMessage;

    /* CHUBB: quoteIdはバックエンドがJWT/セッションから取得するため
       フロントからpostDataで送る必要はない（デッドコード削除済み） */

    /* PAIDY */
    if(this.postData.payment_method == this.appConfig.reservation.paymentType.paidy){
      var paidy_id = <HTMLInputElement>document.getElementById('paidy_id');
      var paidy_amount = <HTMLInputElement>document.getElementById('paidy_amount');
      var paidy_currency = <HTMLInputElement>document.getElementById('paidy_currency');
      var paidy_created = <HTMLInputElement>document.getElementById('paidy_created');
      var paidy_status = <HTMLInputElement>document.getElementById('paidy_status');
      if(paidy_status.value != 'authorized'){
        this.postData.paidy_id = '';
        this.postData.paidy_amount = '';
        this.postData.paidy_currency = '';
        this.postData.paidy_created = '';
        this.postData.paidy_status = '';
        /* GET ERROR MESSAGE */
        let message = [];
        message.push(`あと払い（ペイディ）での決済に失敗致しました。`);
        message.push(`ご情報をご確認ください。`);
        this.tempData.checkOutErrorMessage = message.join("<br>");
        /* END */
        this.commonService.hidePageLoader();
        return this.commonService.redirectToRoute(this.commonService.routePaths.pageReserveCheckoutNoParam);

      } else {
        this.postData.paidy_id = paidy_id.value;
        this.postData.paidy_amount = paidy_amount.value;
        this.postData.paidy_currency = paidy_currency.value;
        this.postData.paidy_created = paidy_created.value;
        this.postData.paidy_status = paidy_status.value;
      }
    }
    /* PAIDY */

    /* CARD */
    // [CR-FRONT-06] PCI-DSS対応: カード生データとtokenの冗長コピーを削除
    //   - payment画面(514-515行目)で session_token と token の両方にVeritransトークンをセット
    //   - バックエンド(ReserveController.php:1642)は session_token を参照する
    //   - ここで削除する token は冗長コピーであり、session_token は残るため決済に影響なし
    //   - card_no/card_expdate/card_cvv2 はPCI-DSS修正(e7c25c2d)で既にpostDataに保存されなくなっている
    if(this.postData.payment_method == this.appConfig.reservation.paymentType.creditCard){
        delete this.postData.token;
        delete this.postData.card_no;
        delete this.postData.card_expdate;
        delete this.postData.card_cvv2;
    }
    /* CARD */

    /* SAVE RESERVATION DATA FOR NEXT PAGE */
    this.reservationService.saveReservationData(this.postData);
    this.analyticsService.confirmReservation(
      this.cartData,
      this.postData,
      this.priceCalculation,
      this.divisionData
    );

    let returnData = await this.reservationService.proceedToBooking(this.postData);
    if (returnData) {
      if (returnData.status == "success") {
        /* SAVE FINISHED DATA */
        this.reservationService.saveReservationCompleteData(returnData);

        /* GO TO NEXT PAGE */
        return this.commonService.redirectToRoute(this.commonService.routePaths.pageReserveFinish);
      } else {
        this.commonService.removeBatchData([
          this.appConfig.reservation.reservationCompleteDataSessionName,
        ]);

        /* CHECK IF CREDIT CARD ERRORS */
        if (returnData.data.info || returnData.data.info_code) {
          /* SAVE ERROR DATA TO NEXT PAGE */
          this.commonService.setData(this.appConfig.reservation.errorCreditCardSessionName, returnData.data);

          /* GO TO PAYMENT PAGE */
          return this.commonService.redirectToRoute(this.commonService.routePaths.pageReservePaymentNoParam);
        }

        /* GET ERROR MESSAGE */
        let message = [];
        if (Array.isArray(returnData.data)) {
          for (let item of returnData.data) {
            for (let key in item) {
              message.push(item[key]);
            }
          }
        } else {
          for (let key in returnData.data) {
            message.push(returnData.data[key]);
          }
        }
        message.push(`ご情報をご確認ください。`);
        this.tempData.checkOutErrorMessage = message.join("<br>");
        /* END */

        this.commonService.hidePageLoader();

        let is_show_popup = this.activatedRoute.snapshot.queryParams.is_show_popup === '1';
        if(is_show_popup) {
          //Remove session cart
          this.showPopError()
          return {};
        }
        return this.commonService.redirectToRoute(this.commonService.routePaths.pageReserveCheckoutNoParam);
      }
    } else {
      this.commonService.removeBatchData([
        this.appConfig.reservation.reservationCompleteDataSessionName,
      ]);
    }

    } catch (e) {
      console.error('finalStep error:', e);
    }

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async paidyPay() {
    this.postData = this.reservationService.getReservationData();
    this.cartData = this.cartService.getCartData();
    let userData = JSON.parse(localStorage.getItem(this.appConfig.auth.loginSessionName));

    var paidy_config = {
      // "api_key": "pk_test_207v68uhmdd5vfgthd8rpstr4u",
      "api_key": this.busSettings.payment.paidy.api_key,
      "logo_url": "http://www.paidy.com/images/logo.png",
      "closed": function(callbackData) {
        var paidy_id = <HTMLInputElement>document.getElementById('paidy_id');
        var paidy_amount = <HTMLInputElement>document.getElementById('paidy_amount');
        var paidy_currency = <HTMLInputElement>document.getElementById('paidy_currency');
        var paidy_created = <HTMLInputElement>document.getElementById('paidy_created');
        var paidy_status = <HTMLInputElement>document.getElementById('paidy_status');
        paidy_id.value = callbackData.id;
        paidy_amount.value = callbackData.amount;
        paidy_currency.value = callbackData.currency;
        paidy_created.value = callbackData.created_at;
        paidy_status.value = callbackData.status;

        var checkoutSubmit = document.getElementById('checkoutSubmit');
        checkoutSubmit.click();
      },
    };

    let paidy_items: any = [];
    for (let i = 0; i < this.cartData.length; i++) {
      if(0 < this.cartData[i].passenger.adult.total){
        paidy_items.push(
          {
            "id": this.cartData[i].plan.bus_code,
            "title": "大人料金",
            "quantity": this.cartData[i].passenger.adult.total,
            "unit_price": this.cartData[i].plan.price,
          }
        );
      }
      if(0 < this.cartData[i].passenger.children.total){
        paidy_items.push(
          {
            "id": this.cartData[i].plan.bus_code,
            "title": "子供料金",
            "quantity": this.cartData[i].passenger.children.total,
            "unit_price": this.cartData[i].plan.price_child,
          }
        );
      }
    }

    if(!this._.isEmpty(this.couponData)){
      paidy_items.push(
        {
          "id": this.couponData.code,
          "title": this.couponData.name,
          "quantity": 1,
          "unit_price": this.couponData.discountDisplay*-1,
        }
      );
    }

    if(0 < this.priceCalculation.insurancePrice){
      paidy_items.push(
        {
          "title": "国内旅行傷害保険",
          "quantity": 1,
          "unit_price": this.priceCalculation.insurancePrice,
        }
      );
    }

    if(0 < this.priceCalculation.zurichInsurancePrice){
      paidy_items.push(
        {
          "title": "キャンセル費用保険",
          "quantity": 1,
          "unit_price": this.priceCalculation.zurichInsurancePrice,
        }
      );
    }

    let buyer_data: any = {};
    if(userData){
      buyer_data.user_id = userData.userData.id;
      buyer_data.age = userData.userData.created_age; //ユーザーアカウント作成経過日数
      buyer_data.ltv = userData.userData.total_price; //ユーザー総予約金額
      buyer_data.order_count = userData.userData.reserve_count; //ユーザー注文総数
      buyer_data.last_order_amount = userData.userData.last_price; //ユーザー最新予約金額
      buyer_data.last_order_at = userData.userData.last_reserve_age; //ユーザー最終予約経過日数
    } else {
      buyer_data.age = 0; //ユーザーアカウント作成経過日数
      buyer_data.ltv = 0; //ユーザー総予約金額
      buyer_data.order_count = 0; //ユーザー注文総数
      buyer_data.last_order_amount = 0; //ユーザー最新予約金額
      buyer_data.last_order_at = 0; //ユーザー最終予約経過日数
    }



    var paidyHandler = Paidy.configure(paidy_config);
    var payload = {
      "store_name": "バスブックマーク",
      "amount": this.priceCalculation.totalCartPrice,
      "currency":"JPY",
      "buyer": {
        "email": this.postData['c_mail'],
        "phone" : this.postData['c_tel'],
        // "phone" : "08000000001", //テスト用
        // "email": "successful.payment@paidy.com", //テスト用
        // "name1": this.postData['c_sei']+'　'+this.postData['c_mei'],
        "name2": this.postData['c_sei']+'　'+this.postData['c_mei']
      },
      "buyer_data": buyer_data,
      // "buyer_data": {
      // //     "age": userData.userData.created_age, //ユーザーアカウント作成経過日数
      // //     "ltv": userData.userData.total_price, //ユーザー総予約金額
      // //     "order_count": userData.userData.reserve_count, //ユーザー注文総数
      // //     "last_order_amount": userData.userData.last_price, //ユーザー最新予約金額
      // //     "last_order_at": userData.userData.last_reserve_age, //ユーザー最終予約経過日数
      //     // "age": 0, //ユーザーアカウント作成経過日数
      //     // "ltv": 0, //ユーザー総予約金額
      //     // "order_count": 0, //ユーザー注文総数
      //     // "last_order_amount": 0, //ユーザー最新予約金額
      //     // "last_order_at": 0, //ユーザー最終予約経過日数
      // },
      "order": {
        // "items":[{
        //     "quantity":"1", //注文商品数
        //     "unit_price":"1000", //注文商品の金額
        // }],
        "items":paidy_items,
      },
    }

    paidyHandler.launch(payload);
  }

  async credit3d() {
    this.postData = this.reservationService.getReservationData();
    this.cartData = this.cartService.getCartData();
    let userData = JSON.parse(localStorage.getItem(this.appConfig.auth.loginSessionName));

    var paidy_config = {
      // "api_key": "pk_test_207v68uhmdd5vfgthd8rpstr4u",
      "api_key": this.busSettings.payment.paidy.api_key,
      "logo_url": "http://www.paidy.com/images/logo.png",
      "closed": function(callbackData) {
        var paidy_id = <HTMLInputElement>document.getElementById('paidy_id');
        var paidy_amount = <HTMLInputElement>document.getElementById('paidy_amount');
        var paidy_currency = <HTMLInputElement>document.getElementById('paidy_currency');
        var paidy_created = <HTMLInputElement>document.getElementById('paidy_created');
        var paidy_status = <HTMLInputElement>document.getElementById('paidy_status');
        paidy_id.value = callbackData.id;
        paidy_amount.value = callbackData.amount;
        paidy_currency.value = callbackData.currency;
        paidy_created.value = callbackData.created_at;
        paidy_status.value = callbackData.status;

        var checkoutSubmit = document.getElementById('checkoutSubmit');
        checkoutSubmit.click();
      },
    };

    let paidy_items: any = [];
    for (let i = 0; i < this.cartData.length; i++) {
      if(0 < this.cartData[i].passenger.adult.total){
        paidy_items.push(
          {
            "id": this.cartData[i].plan.bus_code,
            "title": "大人料金",
            "quantity": this.cartData[i].passenger.adult.total,
            "unit_price": this.cartData[i].plan.price,
          }
        );
      }
      if(0 < this.cartData[i].passenger.children.total){
        paidy_items.push(
          {
            "id": this.cartData[i].plan.bus_code,
            "title": "子供料金",
            "quantity": this.cartData[i].passenger.children.total,
            "unit_price": this.cartData[i].plan.price_child,
          }
        );
      }
    }

    if(!this._.isEmpty(this.couponData)){
      paidy_items.push(
        {
          "id": this.couponData.code,
          "title": this.couponData.name,
          "quantity": 1,
          "unit_price": this.couponData.discountDisplay*-1,
        }
      );
    }

    if(0 < this.priceCalculation.insurancePrice){
      paidy_items.push(
        {
          "title": "国内旅行傷害保険",
          "quantity": 1,
          "unit_price": this.priceCalculation.insurancePrice,
        }
      );
    }

    if(0 < this.priceCalculation.zurichInsurancePrice){
      paidy_items.push(
        {
          "title": "キャンセル費用保険",
          "quantity": 1,
          "unit_price": this.priceCalculation.zurichInsurancePrice,
        }
      );
    }

    let buyer_data: any = {};
    if(userData){
      buyer_data.user_id = userData.userData.id;
      buyer_data.age = userData.userData.created_age; //ユーザーアカウント作成経過日数
      buyer_data.ltv = userData.userData.total_price; //ユーザー総予約金額
      buyer_data.order_count = userData.userData.reserve_count; //ユーザー注文総数
      buyer_data.last_order_amount = userData.userData.last_price; //ユーザー最新予約金額
      buyer_data.last_order_at = userData.userData.last_reserve_age; //ユーザー最終予約経過日数
    } else {
      buyer_data.age = 0; //ユーザーアカウント作成経過日数
      buyer_data.ltv = 0; //ユーザー総予約金額
      buyer_data.order_count = 0; //ユーザー注文総数
      buyer_data.last_order_amount = 0; //ユーザー最新予約金額
      buyer_data.last_order_at = 0; //ユーザー最終予約経過日数
    }



    var paidyHandler = Paidy.configure(paidy_config);
    var payload = {
      "store_name": "バスブックマーク",
      "amount": this.priceCalculation.totalCartPrice,
      "currency":"JPY",
      "buyer": {
        "email": this.postData['c_mail'],
        "phone" : this.postData['c_tel'],
        // "phone" : "08000000001", //テスト用
        // "email": "successful.payment@paidy.com", //テスト用
        // "name1": this.postData['c_sei']+'　'+this.postData['c_mei'],
        "name2": this.postData['c_sei']+'　'+this.postData['c_mei']
      },
      "buyer_data": buyer_data,
      // "buyer_data": {
      // //     "age": userData.userData.created_age, //ユーザーアカウント作成経過日数
      // //     "ltv": userData.userData.total_price, //ユーザー総予約金額
      // //     "order_count": userData.userData.reserve_count, //ユーザー注文総数
      // //     "last_order_amount": userData.userData.last_price, //ユーザー最新予約金額
      // //     "last_order_at": userData.userData.last_reserve_age, //ユーザー最終予約経過日数
      //     // "age": 0, //ユーザーアカウント作成経過日数
      //     // "ltv": 0, //ユーザー総予約金額
      //     // "order_count": 0, //ユーザー注文総数
      //     // "last_order_amount": 0, //ユーザー最新予約金額
      //     // "last_order_at": 0, //ユーザー最終予約経過日数
      // },
      "order": {
        // "items":[{
        //     "quantity":"1", //注文商品数
        //     "unit_price":"1000", //注文商品の金額
        // }],
        "items":paidy_items,
      },
    }

    paidyHandler.launch(payload);
  }

  showPopError() {
    let msg_error = `予約を完了できませんでした。<br>空席が不足しているため、予約がお取りできませんでした。<br><br>大変恐れ入りますが、別の便をご検討いただけますようお願いいたします。`
    this.commonService.removeData(this.appConfig.cart.cartSessionName);
    let $ = this.commonService.getJQuery();
    $("#commonMsgModal").modal();
    $("#commonMsgModal .modal-body p").html(msg_error);
  }
}
